import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateDatasetSettingsState from './datasetSettings';
import updateDatasetState from './dataset';

const handlers = {
  ...updateDatasetSettingsState,
  ...updateDatasetState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
